"use client";

import { Check, ChevronsUpDown, Plus } from "lucide-react";
import Link from "next/link";

import { useDevices } from "@/components/device-provider";
import { SparkTile } from "@/components/spark-tile";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";

// Which device the console shows: the parent's linked devices by display name
// (child-flavored, chosen at link time — TZ-471).
export function DeviceSwitcher() {
  const { devices, selected, select } = useDevices();

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton size="lg" className="data-[state=open]:bg-sidebar-accent">
              <SparkTile className="size-8" />
              <div className="grid flex-1 text-left leading-tight">
                <span className="truncate font-medium text-sm">{selected.name}</span>
                <span className="truncate text-muted-foreground text-xs">First Magic device</span>
              </div>
              <ChevronsUpDown className="ml-auto size-4 text-muted-foreground" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-(--radix-dropdown-menu-trigger-width) min-w-56"
            align="start"
          >
            <DropdownMenuLabel className="text-muted-foreground text-xs">Devices</DropdownMenuLabel>
            {devices.map((device) => (
              <DropdownMenuItem key={device.device_id} onClick={() => select(device.device_id)}>
                <span aria-hidden className="text-spark">
                  ✦
                </span>
                <span className="truncate">{device.name}</span>
                {device.device_id === selected.device_id && <Check className="ml-auto size-4" />}
              </DropdownMenuItem>
            ))}
            <DropdownMenuSeparator />
            <DropdownMenuItem asChild>
              {/* ?back=1: the parent has devices, so the form shows a way back. */}
              <Link href="/link-device?back=1">
                <Plus />
                Add device
              </Link>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
